import { Link } from "react-router-dom";
import { Panel } from "@/components/app/common";
import { inr0 as inr } from "@/lib/format";

const TILES = [["draft", "Draft", "Being prepared"], ["shared", "Shared", "With the customer"], ["won", "Won", "Ready to convert to LM"]];

// Open quotations (latest revisions) by status; basic value excl. GST; each tile opens the filtered list.
export function QuotePipeline({ quotes }) {
  if (!quotes) return null;
  return (
    <Panel title="Open quotations (basic value, excl. GST)" testid="dashboard-quote-pipeline" className="mt-5">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {TILES.map(([k, l, sub]) => {
          const b = quotes[k];
          return (
            <Link key={k} to={`/sales/quotes?status=${k}`} className="rounded border border-slate-200 p-3 hover:border-sky-400 hover:bg-sky-50 transition-colors" data-testid={`dashboard-quotes-${k}`}>
              <div className="text-[11px] uppercase tracking-wider text-slate-500">{l} · {b.lms} quote{b.lms === 1 ? "" : "s"}</div>
              <div className="text-xl font-semibold font-mono mt-1">{inr(b.value)}</div>
              <div className="text-xs text-slate-500">{sub}{b.expired > 0 && <span className="text-amber-700"> · {b.expired} past validity</span>}</div>
            </Link>
          );
        })}
      </div>
    </Panel>
  );
}
